var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99145 11.2684C11.1516 11.2684 12.2239 10.9415 13.0817 10.386C13.7461 9.96062 14.611 10.0309 15.1946 10.5618C16.8153 12.0313 17.7364 14.1161 17.7329 16.3063V17.245C17.7329 18.2153 16.9454 18.9993 15.975 18.9993H4.00785C3.03754 18.9993 2.25004 18.2153 2.25004 17.245V16.3063C2.24301 14.1196 3.1641 12.0313 4.78481 10.5653C5.3684 10.0344 6.23676 9.96413 6.8977 10.3895C7.75902 10.9415 8.82777 11.2684 9.99145 11.2684Z",
    fill: "#BFBFBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99102 9.70469C12.3947 9.70469 14.3434 7.75608 14.3434 5.35234C14.3434 2.94861 12.3947 1 9.99102 1C7.58728 1 5.63867 2.94861 5.63867 5.35234C5.63867 7.75608 7.58728 9.70469 9.99102 9.70469Z",
    fill: "#BFBFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.11a5526abbb2c4418fb7f67434094cc8.svg";
export { ForwardRef as ReactComponent };